import { useCallback, useState } from 'react'
import { PaginaCrud } from '../components/PaginaCrud'
import type { MovimientoInventario } from '../types'

const hoy = new Date().toLocaleDateString('sv-SE')

export default function Movimientos() {
  const [desde, setDesde] = useState(hoy)
  const [hasta, setHasta] = useState(hoy)

  const filtro = useCallback((m: MovimientoInventario) => {
    if (!m.fechaRegistro) return !(desde || hasta)
    const fecha = m.fechaRegistro.slice(0, 10)
    if (desde && fecha < desde) return false
    if (hasta && fecha > hasta) return false
    return true
  }, [desde, hasta])

  return (
    <PaginaCrud<MovimientoInventario>
      titulo="Movimientos de Inventario"
      recurso="movimientosinventario"
      llave="id"
      columnas={[
        { campo: 'productoSKU', titulo: 'SKU' },
        { campo: 'productoNombre', titulo: 'Producto' },
        { campo: 'tipoMovimiento', titulo: 'Tipo' },
        { campo: 'cantidad', titulo: 'Cantidad' },
        { campo: 'almacenNombre', titulo: 'Almacen' },
        { campo: 'ubicacionCodigo', titulo: 'Ubicacion', render: (m) => m.ubicacionCodigo || '-' },
        { campo: 'loteCodigo', titulo: 'Lote', render: (m) => m.loteCodigo || '-' },
        { campo: 'referencia', titulo: 'Referencia', render: (m) => m.referencia || '-' },
        { campo: 'fechaRegistro', titulo: 'Fecha Registro', render: (m) => (m.fechaRegistro ? new Date(m.fechaRegistro).toLocaleString('es-ES', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' }).replace(/, /g, ' ').replace(/\//g, '-') : '-') },
      ]}
      campos={[
        { nombre: 'productoId', etiqueta: 'Producto ID', tipo: 'numero', requerido: true },
        { nombre: 'almacenId', etiqueta: 'Almacen ID', tipo: 'numero', requerido: true },
        { nombre: 'ubicacionId', etiqueta: 'Ubicacion ID', tipo: 'numero' },
        { nombre: 'loteId', etiqueta: 'Lote ID', tipo: 'numero' },
        { nombre: 'tipoMovimiento', etiqueta: 'Tipo', tipo: 'select', requerido: true, opciones: [
          { valor: 'Entrada', texto: 'Entrada' },
          { valor: 'Salida', texto: 'Salida' },
          { valor: 'Ajuste', texto: 'Ajuste' },
          { valor: 'InventarioInicial', texto: 'Inventario inicial' },
        ]},
        { nombre: 'cantidad', etiqueta: 'Cantidad', tipo: 'decimal', requerido: true },
        { nombre: 'referencia', etiqueta: 'Referencia', tipo: 'texto' },
        { nombre: 'usuarioId', etiqueta: 'Usuario ID', tipo: 'numero', requerido: true },
      ]}
      valorInicial={{ tenantId: 1, usuarioId: 1, cantidad: 0, tipoMovimiento: 'Entrada' }}
      puedeEditar={false}
      extras={
        <div className="mb-4 flex flex-col gap-3 rounded-xl bg-superficie p-4 shadow-sm sm:flex-row sm:items-end">
          <div className="flex-1">
            <label className="mb-1 block text-sm font-medium text-texto">Desde</label>
            <input
              type="date"
              value={desde}
              onChange={(e) => setDesde(e.target.value)}
              className="w-full rounded-lg border border-borde bg-superficie-soft px-3 py-2 text-texto focus:border-tema"
            />
          </div>
          <div className="flex-1">
            <label className="mb-1 block text-sm font-medium text-texto">Hasta</label>
            <input
              type="date"
              value={hasta}
              onChange={(e) => setHasta(e.target.value)}
              className="w-full rounded-lg border border-borde bg-superficie-soft px-3 py-2 text-texto focus:border-tema"
            />
          </div>
        </div>
      }
      filtro={filtro}
    />
  )
}
